export const MONDAY_BRIEF_FOCUS_KEY = 'zecure_focus_monday_brief_v1';
export const MONDAY_BRIEF_FOCUS_EVENT = 'zecure:monday-brief-focus';

/** Ask Profit Report to show Brief view and scroll to Monday Brief. */
export function requestMondayBriefFocus(): void {
  try {
    sessionStorage.setItem(MONDAY_BRIEF_FOCUS_KEY, '1');
    window.dispatchEvent(new CustomEvent(MONDAY_BRIEF_FOCUS_EVENT));
  } catch {
    // ignore quota / private mode
  }
}

/** Consume a pending Monday Brief focus request (one-shot). */
export function consumeMondayBriefFocus(): boolean {
  try {
    const raw = sessionStorage.getItem(MONDAY_BRIEF_FOCUS_KEY);
    if (!raw) return false;
    sessionStorage.removeItem(MONDAY_BRIEF_FOCUS_KEY);
    return true;
  } catch {
    return false;
  }
}
